// extracted by mini-css-extract-plugin
export var mt0 = "fp-NC";
export var mt1 = "fp-OC";
export var mt2 = "fp-PC";
export var mt3 = "fp-QC";
export var mt4 = "fp-RC";
export var mt5 = "fp-SC";
export var mt6 = "fp-TC";
export var widgetFastFacts = "fp-UC";
export var widgetFastFacts__eyebrow = "fp-WC";
export var widgetFastFacts__logo = "fp-VC";
export var widgetFastFacts__statItem = "fp-XC";
export var widgetFastFacts__statItem__copy = "fp-ZC";
export var widgetFastFacts__statItem__headline = "fp-YC";